import api from './api';

export const listEnrollments = async (params = {}) => {
  const { data } = await api.get('/enrollments', { params });
  return data;
};

export default {
  listEnrollments,
};
